import { useEffect, useRef, useState } from 'react';
import { Tick, Copy } from '@/components/icons';
import WhatsAppIcon from '@/components/icons/WhatsAppIcon';
import { Button } from '@/components/ui/button';
import { buildWhatsAppUrl } from '@/lib/whatsapp';

interface ShareLinkPanelProps {
    shareText: string;
    shareLink: string;
}

export default function ShareLinkPanel({ shareText, shareLink }: ShareLinkPanelProps) {
    const [copiedLink, setCopiedLink] = useState(false);
    const linkTimeoutRef = useRef<number | null>(null);

    useEffect(() => {
        return () => {
            if (linkTimeoutRef.current) {
                window.clearTimeout(linkTimeoutRef.current);
            }
        };
    }, []);

    const getNormalizedText = () => shareText.normalize('NFC');

    const handleCopyLink = () => {
        navigator.clipboard.writeText(shareLink);
        setCopiedLink(true);
        if (linkTimeoutRef.current) {
            window.clearTimeout(linkTimeoutRef.current);
        }
        linkTimeoutRef.current = window.setTimeout(() => {
            setCopiedLink(false);
        }, 2000);
    };

    const handleWhatsApp = () => {
        window.open(buildWhatsAppUrl(getNormalizedText()), '_blank');
    };

    return (
        <div className="grid grid-cols-1 gap-2 sm:grid-cols-2 sm:gap-3">
            <Button
                variant="outline"
                onClick={handleCopyLink}
                className="flex w-full items-center justify-center gap-2"
            >
                {copiedLink ? <Tick className="size-4" /> : <Copy className="size-4" />}
                {copiedLink ? 'Copiado' : 'Copiar Link'}
            </Button>
            <Button
                onClick={handleWhatsApp}
                className="flex w-full items-center justify-center gap-2 border-none bg-[#25D366] text-white hover:bg-[#128C7E]"
            >
                <WhatsAppIcon className="size-4" />
                WhatsApp
            </Button>
        </div>
    );
}
